/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Component imports
import { Button, Result } from 'antd';
import LockIcon from '../assets/icons/lock.png';

// Misc imports
import { NAV_ROOT } from '../constants/navigation';
import is from '../utils/is';

const Permissioned = ({
  children,
  allowedPermissions = [],
  currentPermissions = [],
  fallbackComponent
}) => {
  const inMicrosoftTeams = is.inMicrosoftTeams();
  const { t } = useTranslation();

  return (
    allowedPermissions.some(permission => currentPermissions.includes(permission)) ? (
      <Fragment>
        {children}
      </Fragment>
    ) : !is.undefined(fallbackComponent) ? fallbackComponent : (
      <Result
        title=""
        icon={<img src={LockIcon} alt="Not found" style={{ maxHeight: 160 }} />}
        subTitle={t('Sorry, you are not authorized to access this view. If this is an error please contact an administrator.')}
        extra={
          <Fragment>
            {
              !inMicrosoftTeams
                ? <Link to={NAV_ROOT}>
                  <Button type="primary">
                    {t('Return to Home')}
                  </Button>
                </Link>
                : null
            }
          </Fragment>
        }
      />
    )
  );
};

Permissioned.propTypes = {
  children: PropTypes.node.isRequired,
  allowedPermissions: PropTypes.array.isRequired,
  currentPermissions: PropTypes.array.isRequired,
  fallbackComponent: PropTypes.node
};

export default Permissioned;
